import React, { useState } from "react"

import { SKILLS } from "../../db/skills"
import { SkillsItem } from "../../components"

const Skills = ({ language }) => {
  const [showSkills, setShowSkills] = useState(false)
  setTimeout(() => {
    setShowSkills(true)
  }, 2500)
  return (
    <div className="skills d-flex flex-column align-items-center gap-5 p-4">
      <div className="skills-titles">
        <p className="skills-titles__title m-0">
          {language === "Español"
            ? "Conocimientos y habilidades"
            : "Knowledge and skills"}
        </p>
      </div>
      <ul
        className={
          !showSkills
            ? "skills-container d-flex flex-column aling-items-center gap-4 w-100 m-0 p-0"
            : "skills-container show d-flex flex-column aling-items-center gap-4 w-100 m-0 p-0"
        }
      >
        {SKILLS.map((skill) => (
          <SkillsItem key={skill.id} skill={skill} />
        ))}
      </ul>
    </div>
  )
}

export default Skills
